export const SERVER_USER_TOKEN_COOKIE = 'cc-token'
